import React, { Component } from "react";
import DinamicTable from "../../shared/table";
import StatusBadge from "canvas-core-react/lib/StatusBadge";
import i18next from "i18next";

const headers = [
  {
    selector: "identification",
    name: `${i18next.t("clients.providers.table.headers.identification")}`,
  },
  {
    selector: "institutionName",
    name: `${i18next.t("clients.providers.table.headers.company_name")}`,
  },
  {
    selector: "contact",
    name: `${i18next.t("clients.providers.table.headers.contact")}`,
  },
  // {
  //   selector: "type",
  //   name: `${i18next.t("clients.providers.table.headers.provider_type")}`,
  // },
  {
    selector: "account",
    name: `${i18next.t("clients.providers.table.headers.account")}`,
  },
  {
    selector: "status",
    name: `${i18next.t("clients.providers.table.headers.state")}`,
  },
];

export class TableProvidersByClient extends Component {
  constructor(props) {
    super(props);
    this.state = { page: 0, sizePerPage: props.sizePerPage };
  }

  handleTableChange = ({ page, sizePerPage, sort = "", property = "" }) => {
    const { getProvidersByClient } = this.props;
    var filters =
      property !== "" && property !== null
        ? [{ property: "sort", value: `${property},${sort}` }]
        : [];

    return getProvidersByClient(page, sizePerPage, filters).then(() => {
      this.setState({ page: page, sizePerPage, order: sort, sortBy: property });
    });
  };

  setTableData() {
    let { data } = this.props;
    let dataResult = [];
    let providerType,
      estado = null;

    if (data.length > 0) {
      data.map((item) => {
        let providerAccount =
          item.provider?.accounts[0]?.accountNumber !== null
            ? item.provider.accounts[0]?.accountNumber
            : i18next.t("general.states.INACTIVE");

        if (item.provider.toBillDiscount === true) {
          providerType = i18next.t("general.states.DISCOUNT");
        } else if (item.provider.toBillDiscount === false) {
          providerType = i18next.t("general.states.DDAY");
        }

        if (item.provider.status === "TRANSITORY") {
          estado = (
            <StatusBadge
              className="pending provider-table-attribute"
              type="default"
            >
              {i18next.t("clients.providers.table.headers.pending")}
            </StatusBadge>
          );
        } else if (item.provider.status === "ACTIVE") {
          estado = (
            <StatusBadge
              className="success provider-table-attribute"
              type="success"
            >
              {i18next.t("clients.providers.table.headers.active")}
            </StatusBadge>
          );
        } else if (item.provider.status === "INACTIVE") {
          estado = (
            <StatusBadge
              className="error1 provider-table-attribute"
              type="error"
            >
              {i18next.t("clients.providers.table.headers.inactive")}
            </StatusBadge>
          );
        } else if (item.provider.status === "REJECTED") {
          estado = (
            <StatusBadge
              className="rejected-payment provider-table-attribute"
              type="error"
            >
              {i18next.t("clients.providers.table.headers.rejected")}
            </StatusBadge>
          );
        }

        dataResult.push({
          identification: item.businessId,
          institutionName: item.name,
          contact: item.provider.notificationNameProvider,
          account: providerAccount,
          type: providerType,
          status: estado,
        });
      });
    }

    return dataResult;
  }

  render() {
    const { page, sizePerPage } = this.state;
    const { totalSize } = this.props;
    return (
      <DinamicTable
        headers={headers}
        data={this.setTableData()}
        page={page}
        totalSize={totalSize}
        sizePerPage={sizePerPage}
        onTableChange={this.handleTableChange}
      />
    );
  }
}

export default TableProvidersByClient;
